"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuPrecoupe = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var PrevisuPrecoupe = function PrevisuPrecoupe(props) {
  var largeurCadre = parseFloat(props.largeurCadre);
  var hauteurCadre = parseFloat(props.hauteurCadre);
  var largeurFixe = props.largeurFixe;
  var backgroundPouBlanc = props.backgroundPouBlanc;
  var baguetteLarge;
  var baguettePetit;

  if (largeurCadre > hauteurCadre) {
    baguetteLarge = largeurFixe;
    baguettePetit = hauteurCadre * largeurFixe / largeurCadre;
  } else {
    baguetteLarge = largeurFixe;
    baguettePetit = largeurCadre * largeurFixe / hauteurCadre;
  }

  var epaisseurBaguette = 30;
  var heightMarge = largeurFixe * 30 / 200;
  var divParent = {
    backgroundColor: backgroundPouBlanc,
    paddingTop: "20px",
    paddingBottom: "20px",
    width: largeurFixe,
    marginLeft: largeurFixe === 700 ? "0px" : "10px"
  };
  var baguetteStyle = {
    position: "absolute",
    height: epaisseurBaguette + "px",
    width: baguetteLarge + "px",
    clipPath: "polygon(0 0, " + baguetteLarge + "px 0, " + (baguetteLarge - epaisseurBaguette) + "px " + epaisseurBaguette + "px, " + epaisseurBaguette + "px " + epaisseurBaguette + "px)"
  };
  var baguetteStyle1 = {
    position: "absolute",
    width: baguettePetit + "px",
    clipPath: "polygon(0 0, " + baguettePetit + "px 0, " + (baguettePetit - epaisseurBaguette) + "px " + epaisseurBaguette + "px, " + epaisseurBaguette + "px " + epaisseurBaguette + "px)",
    height: epaisseurBaguette + "px",
    marginBottom: epaisseurBaguette + "px"
  };
  var boxForShadow = {
    filter: "drop-shadow(-1px 3px 3px rgba(50, 50, 0, 0.3))",
    width: baguetteLarge + "px",
    height: epaisseurBaguette + "px"
  };
  var Image = props.imageComponent;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: divParent
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: boxForShadow
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: baguetteStyle
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: props.baguette.imgLongueur,
    style: {
      height: "100%"
    },
    alt: "Baguette1"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: heightMarge + "px"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: boxForShadow
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: baguetteStyle
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: props.baguette.imgLongueur,
    style: {
      height: "100%",
      boxShadow: "5px 5px 6px #5e5447"
    },
    alt: "Baguette2"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: heightMarge + "px"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: boxForShadow
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: baguetteStyle1
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: props.baguette.imgLongueur,
    style: {
      height: "100%",
      boxShadow: "5px 5px 6px #5e5447"
    },
    alt: "Baguette3"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: heightMarge + "px"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: boxForShadow
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: baguetteStyle1
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: props.baguette.imgLongueur,
    style: {
      height: "100%",
      boxShadow: "5px 5px 6px #5e5447"
    },
    alt: "Baguette4"
  })))));
};

exports.PrevisuPrecoupe = PrevisuPrecoupe;
PrevisuPrecoupe.propTypes = {
  baguette: _propTypes.default.shape({
    imgLongueur: _propTypes.default.object
  }),
  largeurFixe: _propTypes.default.number,
  largeurCadre: _propTypes.default.number,
  hauteurCadre: _propTypes.default.number,
  backgroundPouBlanc: _propTypes.default.string,
  imageComponent: _propTypes.default.element
};
var _default = PrevisuPrecoupe;
exports.default = _default;